export const API = `${process.env.REACT_APP_API}/api`;
export const publicAPI = `${API}/public`;
export const commonAPI = `${API}/common`;
export const adminAPI = `${API}/admin`;
